import { render, staticRenderFns } from "./RootsOfUnityViz.vue?vue&type=template&id=1bee4f39&scoped=true"
import script from "./RootsOfUnityViz.vue?vue&type=script&lang=js"
export * from "./RootsOfUnityViz.vue?vue&type=script&lang=js"
import style0 from "./RootsOfUnityViz.vue?vue&type=style&index=0&id=1bee4f39&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bee4f39",
  null
  
)

export default component.exports